import { BreadcrumbItem } from 'element-ui'

const YBreadcrumbItem = BreadcrumbItem
YBreadcrumbItem.$depends = [BreadcrumbItem]
YBreadcrumbItem.$name = 'y-breadcrumbItem'
YBreadcrumbItem._name = 'BreadcrumbItem 面包屑选项'

export default YBreadcrumbItem
